import asyncService from '../../../../../../../datahub/asyncService';
import { getEmployeeDocumentation, getOnboardingDocuments } from '../../../../usersListReducer';

import { entityTypes } from './constants';

// documents/read has no documentType filter today, so the history fetch pulls the
// max page size and the specific type is filtered out on the client.
export const DOCUMENT_HISTORY_FETCH_LIMIT = 100;

export const fetchDocumentHistory = (dispatch, userId) => {
  if (!userId) return;

  dispatch(
    getEmployeeDocumentation({
      entityType: entityTypes.user,
      entityId: userId,
      limit: DOCUMENT_HISTORY_FETCH_LIMIT,
    })
  );
};

export const fetchOnboardingDocuments = (dispatch, userId) => {
  if (!userId) return;

  dispatch(getOnboardingDocuments({ userId }));
};

export const refreshDocumentation = (dispatch, userId) => {
  fetchDocumentHistory(dispatch, userId);
  fetchOnboardingDocuments(dispatch, userId);
};

export const postDocumentAction = ({ route, data, dispatch, token, refreshToken }) =>
  new Promise((resolve, reject) => {
    asyncService({
      httpMethod: 'POST',
      route,
      data,
      onSuccess: (response) => resolve(response),
      onError: (error) => reject(error),
      dispatch,
      token,
      refreshToken,
    });
  });
